<template>
  <div class="serviceway">
    <uni-popup ref="bloodsugarstate" type="bottom">
      <picker-view
        :value="selectValue"
        class="picker-view"
        :indicator-style="indicatorStyle"
        @change="change"
      >
        <picker-view-column>
          <div v-for="(item, index) in exeDeptList" :key="index" class="item">
            {{ item.deptName }}
          </div>
        </picker-view-column>
      </picker-view>
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValue } from '@/views/funcPuzzle/utils/util.js'

export default {
  props: {
    value: {
      type: [String, Array, Object],
      default: ''
    },
    exeDeptList: {
      type: [Array],
      default: () => {
        return []
      }
    }
  },
  computed: {
    selectValue: {
      get() {
        return ''
      },
      set(item) {
        const deptCode = this.exeDeptList[item.detail.value[0]].deptCode
        const deptName = this.exeDeptList[item.detail.value[0]].deptName

        this.$emit('input', deptCode, deptName)
      }
    }
  },
  data() {
    return {
      indicatorStyle: 'height: 1.066667rem;'
    }
  },

  methods: {
    getKeyValue,
    open() {
      this.$refs.bloodsugarstate.open()
    },
    change(item) {
      const deptCode = this.exeDeptList[item.detail.value[0]].deptCode
      const deptName = this.exeDeptList[item.detail.value[0]].deptName

      this.$emit('change', {
        val: deptCode,
        val2: deptName
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .picker-view {
  height: 10.666667rem;
  background: #fff;
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 1.066667rem;
  }
}
</style>
